import type { SidebarGroupId } from '@/utils/hooks'
import { Navigate } from 'react-router'
import { useSidebarConfig } from './sidebar-config'

interface SidebarGroupRedirectProps {
  groupId: SidebarGroupId
}

/**
 * Gives a sidebar group's URL prefix a page of its own, so its breadcrumb lands
 * on the first page in the group the user can see.
 */
export const SidebarGroupRedirect: React.FC<SidebarGroupRedirectProps> = ({
  groupId,
}) => {
  const config = useSidebarConfig()

  const group = config.find(
    item => item.type === 'group' && item.id === groupId
  )
  const to = group?.type === 'group' ? group.items[0]?.to : undefined

  return <Navigate to={to ?? '/dashboard'} replace />
}
